// extracted by mini-css-extract-plugin
export default {"DialogHeader":"InformationButton_DialogHeader__3DcAT","Button":"InformationButton_Button__M0O-n"};